import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function uploadImage(params) {
	return client.post("seller/po/upload-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}

function getStatusPembelian(params) {
	return client.get("seller/po/data-status", {
		params: params,
	});
}

function getPesananDetailShipmentAdmin(params) {
	return client.get("seller/po_admin/detail-shipment", {
		params: params,
	});
}

function getPembelianDetailAdmin(params) {
	return client.get("seller/po_admin/detail", {
		params: params,
	});
}

function cancelMidtrans(params) {
	return client.post("seller/po/cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function saveSnap(params) {
	return client.post("seller/po/save-snap", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getListProduk(params) {
	return client.get("seller/product/data-for-po", {
		params: params,
	});
}

function getListSupplier(params) {
	return client.get("seller/product/data-supplier-for-po", {
		params: params,
	});
}

function getPembelian(params) {
	return client.get("seller/po/data", {
		params: params,
	});
}

function getPembelianDetail(params) {
	return client.get("seller/po/detail", {
		params: params,
	});
}

function getShippingFee(params) {
	return client.get("common/ongkir-po", {
		params: params,
	});
}

function getShippingFeeKiriminajaExpress(params) {
	return client.get("expka/ongkir/search-express-po", {
		params: params,
	});
}

function getShippingFeeKiriminajaInstant(params) {
	return client.get("expka/ongkir/search-instant-po", {
		params: params,
	});
}

function createPembelian(params) {
	return client.post("seller/po/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function createPembelianKiriminaja(params) {
	return client.post("seller/po/create-kiriminaja", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}


function getCourierMarketplace() {
	return client.get("seller/po/get-courier-marketplace");
}


function getResellerType() {
	return client.get("seller/po/get-reseller-type");
}

function notificationPembelian(params) {
	return client.post("seller/po/notification", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deletePembelian(params) {
	return client.post("seller/po/deletepo", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function choosePayment(params) {
	return client.post("seller/po/choosepayment", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}


function bayarPembelian(params) {
	return client.post("seller/po/process", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function receivePembelian(params) {
	return client.post("seller/po/receive", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getHistoryTracking(params) {
	return client.get("public/tracking/get-history-tracking-po", {
		params: params,
	});
}
function getTrackingKiriminaja(params) {
	return client.get("expka/tracking/get-tracking-po", {
		params: params,
	});
}
function getTracking(params) {
	return client.get("public/tracking/get-tracking-po", {
		params: params,
	});
}

export default {
	createPembelianKiriminaja,
	getStatusPembelian,
	getListProduk,
	getPembelian,
	getPembelianDetail,
	getShippingFee,
	createPembelian,
	bayarPembelian,
	receivePembelian,
	saveSnap,
	deletePembelian,
	notificationPembelian,
	choosePayment,
	cancelMidtrans,
	getHistoryTracking,
	getTracking,
	getListSupplier,
	getResellerType,
	getCourierMarketplace,
	uploadImage,
	getShippingFeeKiriminajaExpress,
	getShippingFeeKiriminajaInstant,
	getPesananDetailShipmentAdmin,
	getTrackingKiriminaja,
	getPembelianDetailAdmin
};